import React, { useEffect } from "react";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-secondary-900 pt-20 pb-12">
        <div className="container-custom">
          <a
            href="/"
            className="inline-flex items-center text-textSpecial2-500 hover:text-primary-500 transition-colors mb-6 text-sm"
          >
            <svg
              className="w-4 h-4 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
            Powrót do strony głównej
          </a>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-light font-heading text-white">
            Polityka Prywatności
          </h1>
        </div>
      </div>

      {/* Content */}
      <div className="container-custom py-12 md:py-16">
        <div className="max-w-4xl">
          <p className="text-secondary-500 text-sm mb-12">
            Ostatnia aktualizacja: 15 marca 2026 r.
          </p>

          {/* 1. Administrator */}
          <section className="mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-secondary-900 mb-4">
              1. Administrator danych osobowych
            </h2>
            <p className="text-secondary-600 leading-relaxed">
              Administratorem Twoich danych osobowych jest{" "}
              <strong>Lumat Łukasz Wojtczuk</strong>, z siedzibą pod adresem
              ul. Św. Proroka Eliasza 4, 15-568 Białystok.
            </p>
            <p className="text-secondary-600 leading-relaxed mt-3">
              Kontakt z Administratorem:{" "}
              <a
                href="mailto:biuro@lumat.com.pl"
                className="text-textSpecial2-500 hover:underline"
              >
                biuro@lumat.com.pl
              </a>
              , tel.{" "}
              <a
                href="tel:+48602476604"
                className="text-textSpecial2-500 hover:underline"
              >
                602 476 604
              </a>
              .
            </p>
          </section>

          {/* 2. Cele i podstawy prawne */}
          <section className="mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-secondary-900 mb-4">
              2. Cele i podstawy prawne przetwarzania danych
            </h2>
            <p className="text-secondary-600 leading-relaxed mb-4">
              Twoje dane osobowe przetwarzane są w następujących celach:
            </p>
            <ul className="space-y-3 text-secondary-600">
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>
                  <strong>Odpowiedź na zapytania</strong> — realizacja kontaktu
                  telefonicznego, mailowego lub przez formularz kontaktowy
                  (podstawa: art. 6 ust. 1 lit. b) i f) RODO — prawnie
                  uzasadniony interes administratora).
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>
                  <strong>Realizacja umów</strong> — przetwarzanie danych
                  niezbędnych do wykonania umowy lub podjęcia działań przed jej
                  zawarciem (podstawa: art. 6 ust. 1 lit. b) RODO).
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>
                  <strong>Analityka i ulepszanie strony</strong> — zbieranie
                  anonimowych danych statystycznych za pomocą Google Analytics,
                  wyłącznie po wyrażeniu zgody (podstawa: art. 6 ust. 1 lit. a)
                  RODO).
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>
                  <strong>Obowiązki prawne</strong> — wypełnianie obowiązków
                  wynikających z przepisów prawa, np. podatkowych i
                  rachunkowych (podstawa: art. 6 ust. 1 lit. c) RODO).
                </span>
              </li>
            </ul>
          </section>

          {/* 3. Zakres danych */}
          <section className="mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-secondary-900 mb-4">
              3. Zakres zbieranych danych
            </h2>
            <p className="text-secondary-600 leading-relaxed mb-4">
              Zbieramy wyłącznie dane niezbędne do realizacji wymienionych celów:
            </p>
            <ul className="space-y-2 text-secondary-600">
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>dane kontaktowe: imię, nazwisko, adres e-mail, numer telefonu;</span>
              </li>
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>dane firmowe: nazwa firmy, NIP (w przypadku kontrahentów);</span>
              </li>
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>
                  dane techniczne: adres IP, typ przeglądarki, dane analityczne
                  (wyłącznie za zgodą użytkownika).
                </span>
              </li>
            </ul>
            <p className="text-secondary-600 leading-relaxed mt-4">
              Podanie danych osobowych jest dobrowolne, lecz niezbędne do
              udzielenia odpowiedzi na zapytanie lub realizacji umowy.
            </p>
          </section>

          {/* 4. Okres przechowywania */}
          <section className="mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-secondary-900 mb-4">
              4. Okres przechowywania danych
            </h2>
            <p className="text-secondary-600 leading-relaxed">
              Dane osobowe przechowywane są przez okres niezbędny do realizacji
              celów, dla których zostały zebrane, a w szczególności:
            </p>
            <ul className="space-y-2 text-secondary-600 mt-4">
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>
                  dane związane z zapytaniami — przez okres prowadzenia
                  korespondencji i do 12 miesięcy po jej zakończeniu;
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>
                  dane związane z umowami — przez okres trwania umowy oraz
                  wymagany przepisami prawa okres archiwizacji;
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>
                  dane analityczne — przez okres do 14 miesięcy od momentu
                  zebrania.
                </span>
              </li>
            </ul>
          </section>

          {/* 5. Odbiorcy danych */}
          <section className="mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-secondary-900 mb-4">
              5. Odbiorcy danych
            </h2>
            <p className="text-secondary-600 leading-relaxed mb-4">
              Twoje dane mogą być przekazywane następującym kategoriom
              odbiorców:
            </p>
            <ul className="space-y-2 text-secondary-600">
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>
                  dostawcy usług hostingowych — Google LLC (Firebase Hosting);
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>
                  dostawcy narzędzi analitycznych — Google LLC (Google Analytics),
                  wyłącznie po wyrażeniu zgody;
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>
                  organy państwowe — w przypadkach wymaganych przepisami prawa;
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>
                  podmioty świadczące usługi księgowe, prawne i IT na rzecz
                  Administratora.
                </span>
              </li>
            </ul>
          </section>

          {/* 6. Prawa użytkownika */}
          <section className="mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-secondary-900 mb-4">
              6. Twoje prawa
            </h2>
            <p className="text-secondary-600 leading-relaxed mb-4">
              W związku z przetwarzaniem danych osobowych przysługują Ci
              następujące prawa:
            </p>
            <ul className="space-y-2 text-secondary-600">
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>prawo dostępu do treści swoich danych;</span>
              </li>
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>prawo do sprostowania danych;</span>
              </li>
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>prawo do usunięcia danych („prawo do bycia zapomnianym");</span>
              </li>
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>prawo do ograniczenia przetwarzania;</span>
              </li>
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>prawo do przenoszenia danych;</span>
              </li>
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>prawo do wniesienia sprzeciwu wobec przetwarzania;</span>
              </li>
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>
                  prawo do cofnięcia zgody w dowolnym momencie (bez wpływu na
                  zgodność z prawem przetwarzania dokonanego przed cofnięciem).
                </span>
              </li>
            </ul>
            <p className="text-secondary-600 leading-relaxed mt-4">
              W celu realizacji swoich praw skontaktuj się z Administratorem pod
              adresem{" "}
              <a
                href="mailto:biuro@lumat.com.pl"
                className="text-textSpecial2-500 hover:underline"
              >
                biuro@lumat.com.pl
              </a>
              .
            </p>
          </section>

          {/* 7. Pliki cookies */}
          <section className="mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-secondary-900 mb-4">
              7. Pliki cookies
            </h2>
            <p className="text-secondary-600 leading-relaxed mb-4">
              Strona internetowa lumat.com.pl wykorzystuje pliki cookies
              (ciasteczka). Są to niewielkie pliki tekstowe zapisywane na
              urządzeniu użytkownika. Stosujemy następujące rodzaje plików cookies:
            </p>
            <ul className="space-y-2 text-secondary-600">
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>
                  <strong>Niezbędne</strong> — konieczne do prawidłowego
                  funkcjonowania strony, w tym zapamiętania ustawień prywatności;
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>
                  <strong>Analityczne</strong> — pomagają zrozumieć, w jaki sposób
                  użytkownicy korzystają ze strony (Google Analytics);
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>
                  <strong>Marketingowe</strong> — wykorzystywane do personalizacji
                  reklam i śledzenia skuteczności kampanii;
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-textSpecial2-500 mr-3 mt-1 font-bold">—</span>
                <span>
                  <strong>Preferencyjne</strong> — pozwalają zapamiętać
                  indywidualne ustawienia użytkownika.
                </span>
              </li>
            </ul>
            <p className="text-secondary-600 leading-relaxed mt-4">
              Przy pierwszej wizycie na stronie wyświetlany jest baner informujący
              o stosowaniu plików cookies. Możesz w każdej chwili zmienić swoje
              preferencje, korzystając z przycisku „Ustawienia prywatności"
              znajdującego się w prawym dolnym rogu strony.
            </p>
            <p className="text-secondary-600 leading-relaxed mt-3">
              Możesz również zarządzać plikami cookies bezpośrednio w ustawieniach
              swojej przeglądarki internetowej. Wyłączenie plików cookies może
              wpłynąć na funkcjonalność strony.
            </p>
          </section>

          {/* 8. Prawo do skargi */}
          <section className="mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-secondary-900 mb-4">
              8. Prawo do wniesienia skargi
            </h2>
            <p className="text-secondary-600 leading-relaxed">
              Jeśli uważasz, że przetwarzanie Twoich danych osobowych narusza
              przepisy RODO, masz prawo wniesienia skargi do organu nadzorczego —{" "}
              <strong>Prezesa Urzędu Ochrony Danych Osobowych</strong> (ul.
              Stawki 2, 00-193 Warszawa).
            </p>
          </section>

          {/* 9. Profilowanie */}
          <section className="mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-secondary-900 mb-4">
              9. Profilowanie
            </h2>
            <p className="text-secondary-600 leading-relaxed">
              Administrator nie podejmuje zautomatyzowanych decyzji wobec
              użytkowników, w tym decyzji będących wynikiem profilowania.
            </p>
          </section>

          {/* 10. Zmiany */}
          <section className="mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-secondary-900 mb-4">
              10. Zmiany w polityce prywatności
            </h2>
            <p className="text-secondary-600 leading-relaxed">
              Administrator zastrzega sobie prawo do wprowadzania zmian w
              niniejszej Polityce Prywatności. O wszelkich zmianach użytkownicy
              zostaną poinformowani poprzez aktualizację treści na tej stronie.
            </p>
          </section>

          {/* Back link */}
          <div className="pt-8 border-t border-gray-200">
            <a
              href="/"
              className="inline-flex items-center text-textSpecial2-500 hover:text-primary-500 transition-colors text-sm"
            >
              <svg
                className="w-4 h-4 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
              Powrót do strony głównej
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
